import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "measuringPoint" }
const _hoisted_2 = { class: "advice flex" }
const _hoisted_3 = { class: "chartWrapper" }
const _hoisted_4 = { class: "col1_2" }
const _hoisted_5 = { class: "particleContent" }
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, "PM 10", -1)
const _hoisted_8 = { class: "quantity" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_10 = {
  key: 1,
  class: "flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, "PM 2,5", -1)
const _hoisted_12 = { class: "quantity" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_14 = {
  key: 2,
  class: "flex"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("SO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_16 = { class: "quantity" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_18 = {
  key: 3,
  class: "flex"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("NO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_20 = { class: "quantity" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_22 = {
  key: 4,
  class: "flex"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("O"),
  /*#__PURE__*/_createElementVNode("sub", null, "3")
], -1)
const _hoisted_24 = { class: "quantity" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_26 = { class: "lastSevenDays" }
const _hoisted_27 = { class: "flex header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_29 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdvancedGaugeChart = _resolveComponent("AdvancedGaugeChart")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_HistoryGraph = _resolveComponent("HistoryGraph")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarWrapper, {
    title: _ctx.$t('air_quality.title'),
    sidebarComponent: _ctx.sidebarComponent,
    mapComponent: _ctx.mapComponent,
    sidebarLeft: true
  }, {
    default: _withCtx(() => [
      (_ctx.sensor !== null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("air_quality.measuring_point")), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.sensor.name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.sensor.hardware_id), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AdvancedGaugeChart, {
                  percentage: parseInt(_ctx.sensor.measurements?.index) || 0,
                  min: 0,
                  max: 300,
                  bands: [
              {
                from: 0,
                to: 50,
                color: _ctx.aqRangeColors.blue,
                thickness: '45%',
              },
              {
                from: 51,
                to: 100,
                color: _ctx.aqRangeColors.green,
                thickness: '45%',
              },
              {
                from: 101,
                to: 150,
                color: _ctx.aqRangeColors.yellow,
                thickness: '45%',
              },
              {
                from: 151,
                to: 200,
                color: _ctx.aqRangeColors.orange,
                thickness: '45%',
              },
              {
                from: 201,
                to: 250,
                color: _ctx.aqRangeColors.red,
                thickness: '45%',
              },
              {
                from: 251,
                to: 300,
                color: _ctx.aqRangeColors.purple,
                thickness: '45%',
              },
            ]
                }, null, 8, ["percentage", "bands"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.getSensorIndexText(_ctx.sensor.measurements?.index)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("air_quality.description")), 1)
              ])
            ]),
            _createVNode(_component_Accordion, {
              multiple: true,
              class: "particleContentInfo",
              activeIndex: [0, 1, 2],
              onTabOpen: _ctx.handleAccordionOpen,
              onTabClose: _ctx.handleAccordionClose
            }, {
              default: _withCtx(() => [
                (_ctx.sensor.measurements !== null)
                  ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 0 }, {
                      header: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.particles")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("ul", null, [
                            (_ctx.sensor.measurements.PM10 !== null)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                  _hoisted_7,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progressBar", _ctx.getValueColorClass('pm10', _ctx.sensor.measurements.PM10)])
                                  }, [
                                    _createVNode(_component_ProgressBar, {
                                      value: (_ctx.sensor.measurements.PM10 / _ctx.aqRanges.pm10[5]) * 100
                                    }, null, 8, ["value"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_8, [
                                    _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.PM10).toFixed(2)) + " μg/m", 1),
                                    _hoisted_9
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sensor.measurements.PM2_5 !== null)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progressBar", 
                    _ctx.getValueColorClass('pm2_5', _ctx.sensor.measurements.PM2_5)
                  ])
                                  }, [
                                    _createVNode(_component_ProgressBar, {
                                      value: 
                      (_ctx.sensor.measurements.PM2_5 / _ctx.aqRanges.pm2_5[5]) * 100
                    
                                    }, null, 8, ["value"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_12, [
                                    _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.PM2_5).toFixed(2)) + " μg/m", 1),
                                    _hoisted_13
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sensor.measurements.SO2 !== null)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progressBar", 
                    _ctx.getValueColorClass(
                      'so2',
                      _ctx.sensor.measurements.SO2 / 0.000355,
                    )
                  ])
                                  }, [
                                    _createVNode(_component_ProgressBar, {
                                      value: 
                      (_ctx.sensor.measurements.SO2 / 0.000355 / _ctx.aqRanges.so2[5]) *
                      100
                    
                                    }, null, 8, ["value"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_16, [
                                    _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.SO2 / 0.000355).toFixed(2)) + " μg/m", 1),
                                    _hoisted_17
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sensor.measurements.NO2 !== null)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                  _hoisted_19,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progressBar", 
                    _ctx.getValueColorClass(
                      'no2',
                      _ctx.sensor.measurements.NO2 / 0.000494,
                    )
                  ])
                                  }, [
                                    _createVNode(_component_ProgressBar, {
                                      value: 
                      (_ctx.sensor.measurements.NO2 / 0.000494 / _ctx.aqRanges.no2[5]) *
                      100
                    
                                    }, null, 8, ["value"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_20, [
                                    _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.NO2 / 0.000494).toFixed(2)) + " μg/m", 1),
                                    _hoisted_21
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sensor.measurements.O3 !== null)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                  _hoisted_23,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progressBar", 
                    _ctx.getValueColorClass('o3', _ctx.sensor.measurements.O3 / 0.000473)
                  ])
                                  }, [
                                    _createVNode(_component_ProgressBar, {
                                      value: 
                      (_ctx.sensor.measurements.O3 / 0.000473 / _ctx.aqRanges.o3[5]) * 100
                    
                                    }, null, 8, ["value"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_24, [
                                    _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.O3 / 0.000473).toFixed(2)) + " μg/m", 1),
                                    _hoisted_25
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.sensor.history !== null)
                  ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 1 }, {
                      header: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.last_7")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDays, (day, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, [
                                _createTextVNode(_toDisplayString(day), 1),
                                _createElementVNode("small", null, _toDisplayString(_ctx.tableDates[index]), 1)
                              ]))
                            }), 128))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensor.history, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex body",
                              key: index
                            }, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(item[0]), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[1])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[1]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[2])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[2]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[3])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[3]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[4])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[4]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[5])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[5]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[6])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[6]), 1)
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.getValueColorClass('index', item[7])),
                                tabindex: "0"
                              }, [
                                _createElementVNode("small", null, _toDisplayString(item[7]), 1)
                              ], 2)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.sensor.measurements)
                  ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 2 }, {
                      header: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.history_title")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_HistoryGraph, { sensor: _ctx.sensor }, null, 8, ["sensor"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onTabOpen", "onTabClose"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "sidebarComponent", "mapComponent"]))
}